<template>
    <z-page class="train-bank">
        <!-- 搜索栏 -->
        <div class="page-search">
            <div class="search-item">
                <div>搜索：</div>
                <div>
                        <el-select size='mini' v-model="search.text_type" placeholder="请选择">
                            <el-option label="单选题" :value="'single'"></el-option>
                            <el-option label="多选题" :value="'multiple'"></el-option>
                        </el-select>
                </div>
            </div>
            <div class="search-item">
                <div>产品名称：</div>
                <div class="long">
                        <el-select width='' size='mini' v-model="search.productKey" slot="prepend" placeholder="请选择">
                            <el-option v-for="(item,index) in product" :key="index" :label="item.category_name" :value="item.ecsProduct.kfProductKey"></el-option>
                        </el-select>
                </div>
            </div>
            <div @click="searchData" class="search-btn z-btn normal">搜索</div>
            <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
            <div @click="addopen()" class="z-btn normal floatright">添加</div>
        </div>
        <!-- 列表 -->
        <div class="page-list">
            <div class="list-head">
                <div>序号</div>
                <div>题目名称</div>
                <div>题目类型</div>
                <div>操作</div>
            </div>
            <div v-loading='loading' class="list-main">
                <div v-for="(item, index) in data_list" :key="index" class="list-item">
                    <div>{{item.id}}</div>
                    <div>{{item.context||'--'}}</div>
                    <div>{{item.type|tocn}}</div>
                    <div>
                        <span style="padding:5px;" class="font-btn normal" @click="editopen(item)">编辑</span>
                        <span style="padding:5px;"  class="font-btn danger" @click="delopen(item)">删除</span>
                    </div>
                </div>
                <div style="text-align: center" v-if="data_list.length<=0" class="list-item">
                    暂无数据
                </div>
            </div>
        </div>
        <z-pagination
                @sizeChange="getData()"
                @pageChange="handleCurrentChange"
                :current-page.sync="nowpage"
                :page-size="10"
                :total='total'
                >
        </z-pagination>
        <z-windowPop
            v-model="delshow"
            width='454px'
            :black='true'
            :btnshow='true'
            savetext='删除'
            btnClass='danger'
            @confirm="$func.shake(deltrain)"
            top='50%'
            title="提示信息"
            >
                <div class="delmain">
                    <img src="../../assets/img/warn_icon.svg" alt="">
                    <span>是否删除该题目</span>
                </div>
        </z-windowPop>
        <z-windowPop
            v-model="editshow"
            :bgClose='false'
            width='454px'
            height='566px'
            :black='true'
            savetext='保存'
            :btnshow='true'
             @confirm="$func.shake(addtrain)"
            top='50%'
            title="添加/编辑题目"
            >
            <div class="popmain">
                <div class="popitem">
                    <span >*题目：</span>
                    <el-input
                        style="padding-top: 10px;"
                        class="textarea"
                        type="textarea"
                        size='mini'
                        :rows="2"
                        :max='5'
                        placeholder="请输入内容"
                        v-model="now_data.text">
                    </el-input>
                    <span class="maxfont">{{textlength||0}}/100</span>
                </div>
                <div class="popitem">
                    <span >*题目类型：</span>
                    <el-radio v-model="now_data.type" :label="1">单选题</el-radio>
                    <el-radio v-model="now_data.type" :label="2">多选题</el-radio>
                </div>
                <div class="popitem from">
                    <span >*题目来源：</span>
                    <el-select disabled size='mini' v-model="now_data.from" slot="prepend" placeholder="请选择">
                            <el-option v-for="(item,index) in product" :key="index" :label="item.category_name" :value="item.ecsProduct.kfProductKey"></el-option>
                    </el-select>
                </div>
                <div  class="popitem option">
                    <span >*答案选项：</span>
                    
                    <div class="answer" v-for="(item, index) in answer" :key="index">
                        <el-input for size='mini' class="input-with-radio" v-model="item.text" placeholder="请输入内容">
                            <el-radio v-if="now_data.type==1" v-model="now_data.answer" :label="String.fromCharCode(item.title)"  slot="prepend" ></el-radio>
                            <el-checkbox v-else v-model="now_data.answers[index]"  :label="String.fromCharCode(item.title)"  slot="prepend"  ></el-checkbox>
                        </el-input>   
                        <img class="delimg" @click="deloption(item)" v-if="index==(answer.length-1)&&index>2" src="~@/assets/img/del.svg" alt="">
                    </div>
                    
                </div>
                <div @click="addoption" class="popitem addoption">
                    <img src="~@/assets/img/add.svg" alt="">
                    <span>添加选项</span>
                </div>
            </div>
        </z-windowPop>
    </z-page>
</template>
<script>
export default {
    filters:{
        tocn(val){
            return val=='single'?'单选题':'多选题'
        }
    },
    data(){
        return{
            data_list:[],
            total:0,
            now_data:{                               // 添加修改框其他容器  
                id:'',
                answer:'',                                    // 单选题答案容器
                answers:[false,false,false],              // 多选题答案容器
                text:"",    
                type:1,
                from:''
            },
            answer:[                                 // 修改框选项实际容器
                    {
                        title:65,
                        text:''
                    },
                    {
                        title:66,
                        text:''
                    },
                    {
                        title:67,
                        text:''
                    },
                    
                ],
            editshow:false,
            delshow:false,
            loading:false,
            search:{
                text_type:'',
                text:'',
                productKey:''
            },
            nowpage:1,
            searching:{

            },
            product:''
        }
    },
    computed:{
        textlength(){
            return typeof(this.now_data.text)=='undefined'?0:this.now_data.text.length
        },
    },
    created(){
        this.$store.dispatch("getproduct")
            .then(res=>{
                console.log(res);
                
                if(res[0]){
                    this.searching.productKey=res[0].ecsProduct.kfProductKey
                this.search.productKey=res[0].ecsProduct.kfProductKey
                this.search.product=res[0].category_name
                this.searching.product=res[0].category_name
                this.product=res;
                }  
                this.getData(1)
            })
    },
    methods:{
        // 搜索点击事件
        searchData(){
            this.searching=JSON.parse(JSON.stringify(this.search))
            this.getData(1)
        },
        //获取数据
        getData(num){
            this.loading=true
            let url=`/api/supplier/call/questions/get`
            this.$http.post(url,{},{
                params:{
                    from:this.searching.productKey,
                    page:num||this.nowpage,
                    type:this.searching.text_type
                }
            })
            .then(res=>{
                console.log(res);
                
                if(res.code){
                    this.total=res.res_data.total
                    this.data_list=res.res_data.list
                }else{
                    this.errorTip(res.res_data)
                }
                console.log(this.data_list);
                
                this.loading=false
            })
            .catch(err=>{
                this.errorTip(err)
            })
        },
        // 将key字符串翻译成中文
        toform(val){
            console.log(val);
            
            return val
        },
        // 清除搜索按钮点击事件
        clearsearch(){
            this.searching={
                productKey:this.product[0].ecsProduct.kfProductKey
            }
            this.search={}
            this.search.productKey=this.product[0].ecsProduct.kfProductKey
            this.getData()
            
        },
        // 添加按钮点击事件
        addopen(){
            this.now_data={                               
                id:'',
                answer:'',                                    
                answers:[false,false,false],              
                text:"",    
                type:1,
                from:this.toform(this.searching.productKey)
            }
            this.answer=[                    // 修改框选项实际容器
                    {
                        title:65,
                        text:''
                    },
                    {
                        title:66,
                        text:''
                    },
                    {
                        title:67,
                        text:''
                    }
                ],
            this.editshow=true
        },
        // 编辑按钮点击事件
        editopen(item){
            if(typeof(item.options)=='string'){
                item.options=eval("("+item.options+")")
            }
            this.now_data.text=item.context 
            this.answer=[]
            this.now_data.id=item.id
            if(item.type=='single'){
                this.now_data.type=1
                this.now_data.from=this.toform(this.searching.productKey)
                this.now_data.answer=String.fromCharCode(eval('('+item.correct_oprions+')')[0][0]+65)
                item.options.map((element,i,a) => {
                    this.answer.push({
                        title:element[0]+65,
                        text:element[1]
                    })
                });
            }else{
                this.now_data.type=2
                this.now_data.from=this.toform(this.searching.productKey)
                console.log(eval('('+item.correct_oprions+')'));
                    eval('('+item.correct_oprions+')').map((e)=>{
                        this.now_data.answers[e[0]]=true
                    })
                item.options.map((element,i,a) => {
                    this.answer.push({
                        title:element[0]+65,
                        text:element[1]
                    })
                });
            }
            this.editshow=true
        },
        // 删除按钮点击事件
        delopen(item){
            this.now_data.id=item.id
            this.delshow=true
        },
        // 点击删除选项
        deloption(val){
            this.answer.pop()
            this.now_data.answers.pop()
            
        },
        // 点击添加选项
        addoption(){
            this.answer.push({
                        title:this.answer[this.answer.length-1].title+1,
                        text:''
            })
            this.now_data.answers.push(false)
        },
        // 点击保存按钮发送数据
        addtrain(){
            let url = `/api/supplier/call/question/edit`
            let options = this.answer.map((a)=>{
                return a.text
            })
            let correctOprions=[]

            if(this.now_data.type==1){
                correctOprions.push(this.answer[this.now_data.answer.charCodeAt()-65].text)
            }else{
               this.now_data.answers.map((a,b)=>{
                    if(a){
                        correctOprions.push(this.answer[b].text)
                        return b
                    }
                })
            }
            // 要求选项为  ['asdas','asdsad','sada']    形式字符串  只能是单引号，  ABC用索引区分
            this.$http.post(url,{},{
                params:{
                    id:this.now_data.id||null,
                    type:this.now_data.type==1?'single':'multiple',
                    from:this.searching.productKey,
                    context:this.now_data.text||null,
                    options:JSON.stringify(options).replace(/\"/g,"'"),
                    correctOprions:JSON.stringify(correctOprions).replace(/\"/g,"'")
                }
            })
            .then(res=>{
                console.log(res);
                if(res.code=='200'){
                    if(!this.now_data.id){
                        this.successTip('添加成功')
                    }else{
                        this.successTip(res.res_data)
                    }
                }else{
                    this.errorTip(res.res_data)
                }
                this.editshow=false
                this.getData()
            })
            
        },
        //删除题目
        deltrain(){
            let url = `/api/supplier/call/question/edit`
            this.$http.post(url,{},{
                params:{
                    id:this.now_data.id,
                    type:this.now_data.type==1?'single':'multiple',
                    from:this.searching.productKey,
                    context:"['A']",
                    options:"['A','B','C']",
                    correctOprions:this.now_data.type==1?"['A']":"['A','B']",
                    classify:'deleted'
                }
            })
            .then(res=>{
                if(res.code=='200'){
                    this.successTip('删除成功')
                }else{
                    this.errorTip('删除失败')
                }
                this.getData()
                this.delshow=false
            })
        },
        handleCurrentChange(val){
            this.nowpage=val
            this.getData()
        }
    }
}
</script>
<style lang="less" scoped>
.list-head,.list-item{
        >div{
            &:nth-child(1){
                 width: 16%;
             }
             &:nth-child(2){
                 width: 50%;
             }
             &:nth-child(3),&:nth-child(4){
                 width: 17%;
                 text-align: center
             }

        }
        
    }
    .popmain{
        .popitem{
            position: relative;
            margin: 16px;
            .maxfont{
                position: absolute;
                right: 0px;
                bottom: -15px;
                font-size: 10px;
                color: rgba(16, 30, 56, 0.4)
            }
        }
        
        .from{
            .el-input{
                width: 60%;
                background-color:transparent;border:0;
            }
            .el-radio{
                width: 50px;
        }
        }
    }
    .option{
        
        .answer{
            position: relative;
            .delimg{
            position: absolute;
            top:78%;
            transform: translateY(-78%);
            right: 3%;
            cursor: pointer;
            opacity: 0.6;
            transition: 0.3s;
            &:hover{
                opacity: 1;
            }
        }
        }
        
    }
    .addoption{
        position: relative;
        height: 28px;
        width: 85%;
        cursor: pointer;
        border: 1px rgba(205, 209, 212, 1) dashed ;
        img,span{
            position: absolute;
            top: 50%;
        }
        span{
            left: 50%;
            transform: translate(-50%, -50%);
        }
        img{
            left:40%;
            transform: translate(-50%, -50%);
        }
        
    }
</style>
